var map = {
	"./DSCF6013.jpg": 8256,
	"./DSCF6037.jpg": 8795,
	"./DSCF6062.jpg": 676,
	"./DSCF6116.jpg": 3434,
	"./DSCF6131.jpg": 2867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5726;